import PageOrderList from '../../components/page/OrderList.page'

const WorkspaceOrderTab = () => {
  return <PageOrderList withTabs withGroups isCatalogOwner />
}
export default WorkspaceOrderTab
